import * as CubeTree from '../../../cubeTree/index';
import Visit from '../../visit';
import Select from '../../select/index';
import { cubeModify } from '../../../update/cubeModify';
import { updateCubeList } from '../../../update/updateCubeList';
import { updateEnd } from '../../../update/updateEnd';

// 撤销
async function numberKeyStackOut(stackOutItem: StackOutItem|null): Promise<void> {
    let updateList: CubeId[] = findUpdateList(stackOutItem.data);
    let cubeIds: CubeId[] = [];

    stackOutItem.data.forEach((task: UpdateTask): void => {
        cubeIds.push(task.cubeId);
        cubeModify(task.cubeId, task.updateData);
    });
    updateCubeList(updateList);
    Select.clear();
    Select.addGroup(cubeIds);
    Select.panelSelectAsync();
    updateEnd();
}

function findUpdateList(tasks: UpdateTask[]): CubeId[] {
    let result: Set<CubeId> = new Set();

    tasks.forEach((task: UpdateTask): void => {
        if (CubeTree.isInLayer(task.cubeId)) {
            let itsLayer: CubeId = CubeTree.findCubeLayer(task.cubeId);

            result.add(itsLayer);
            return;
        }

        result.add(task.cubeId);
    });

    return Array.from(result);
}

export {
    numberKeyStackOut
};
